import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=46d15caa&scoped=true"
import script from "./UserNotifications.vue?vue&type=script&lang=js"
export * from "./UserNotifications.vue?vue&type=script&lang=js"
import style0 from "./UserNotifications.vue?vue&type=style&index=0&id=46d15caa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d15caa",
  null
  
)

export default component.exports